/** Figma header — mobile 76:1450 (72px), desktop Frame 117 (80px) */
import { homeMobilePaddingX, HOME_MOBILE_MQ } from '../home/homeMobileLayout'

export const headerPaddingX = homeMobilePaddingX

export const headerHeight = {
  xs: 72,
  md: 80,
  lg: 80,
}

export const headerLogoSize = {
  width: 44,
  height: 48,
}

export const headerNavGap = '32px'

export const headerContactButtonSx = {
  height: 45,
  minHeight: 45,
  fontSize: 16,
  lineHeight: '17px',
  p: '14px',
  borderRadius: '50px',
}

export { HOME_MOBILE_MQ as HEADER_MOBILE_MQ }
